import { FC } from 'react';
import { Avatar, Dropdown, Image, Space } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { StyledContainer, StyledLogoutButton } from './ProfileButton.styles';
import type { LogoutButtonProps, ProfileButtonProps } from './ProfileButton.types';
import { useProfileButton } from './hooks/useProfileButton';
import Title from '@/components/Title';

const LogoutButton: FC<LogoutButtonProps> = ({ text, ...props }) => (
  <StyledLogoutButton {...props} type="default" size="large">
    <Space>
      <LogoutOutlined size={32} />
      {text}
    </Space>
  </StyledLogoutButton>
);

export const ProfileButton: FC<ProfileButtonProps> = ({ name, url, ...props }) => {
  const { handleSignOut } = useProfileButton();
  const { t } = useTranslation();

  return (
    <Dropdown {...props} popupRender={() => LogoutButton({ text: t('logout'), onClick: handleSignOut })}>
      <StyledContainer>
        <Avatar size={32} icon={url ? <Image src={url} preview={false} /> : <UserOutlined />} />
        <Title level={5}>{name}</Title>
      </StyledContainer>
    </Dropdown>
  );
};

export default ProfileButton;
